import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface BadgeProps {
    active: boolean
    count: number
}

const CountBadge: FC<BadgeProps> = ({ active, count }) => {
    const { styles } = useStyles(stylesheet, { active })

    return (
        <View style={styles.container}>
            <Typography.Description size="tiny" font="bold" style={styles.count}>
                {count}
            </Typography.Description>
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        userSelect: 'none',
        justifyContent: 'center',
        borderRadius: 8,
        height: 16,
        width: 16,
        variants: {
            active: {
                true: {
                    backgroundColor: ColorEnum.BRICK_600,
                },
                false: {
                    backgroundColor: ColorEnum.WHITE,
                },
            },
        },
    },
    count: {
        textAlign: 'center',
        variants: {
            active: {
                true: {
                    color: ColorEnum.YELLOW_500,
                },
                false: {
                    color: ColorEnum.BRICK_600,
                },
            },
        },
    },
})

export default CountBadge
